<template>
  <LogoSVG />
</template>

<script setup lang="ts">
import LogoSVG from 'assets/tallo-logo.svg';
</script>
